export default __webpack_public_path__ + "static/e46478fd-57d4-4bfd-ab13-72e5d291c33c-2f18dacb06369d030e9eec4c74f5483c.woff";